var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height px-6 pt-15 pt-lg-0",attrs:{"id":"home"}},[_c('v-row',{staticClass:"align-center",staticStyle:{"position":"relative"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('VideoMasonry')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }